import ArtifactGroupType from "../base/ArtifactGroupType";

const WarriorsCrown = {
  id: '99',
  name: 'Warriors Crown',
  icon: 'WarriorsCrown',
  groupIcon: 'FoundationsOfCivilization',
  type: ArtifactGroupType.FOUNDATIONS_OF_CIVILIZATION,
  power: 10,
  gameId: 'WarriorsCrown'
};

export default WarriorsCrown;
